import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { GlobalService } from '../../../global.service';
import { Service } from '../../../services';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
@Component({
  selector: 'app-affiliate-credit',
  templateUrl: './affiliate-credit.component.html',
  styleUrls: ['./affiliate-credit.component.sass']
})
export class AffiliateCreditComponent implements OnInit {
  public tiposPagos;
  public nameOnCard = '';
  public expDate = '';
  public type = '';
  public cardNum = '';
  public cvNum = '';
  public bankCode = '';
  public months;
  public years;
  public selectedMonth = '01';
  public selectedYear;
  public year;
  public cardNumCut;
  public token:string=sessionStorage.getItem("token");
  public selectBan=atob(sessionStorage.getItem("selectBan"));
  @Input() typeCard;
  @Input() infoAfiliation;
  @Input() tiposPago;
  @Input() screen;
  @Output() updateScreen = new EventEmitter();
  @Output() updatetipo = new EventEmitter();
  constructor(private services: Service,private loadingScreenService :LoadingScreenService, private global:GlobalService) { }

  ngOnInit() {
    this.tiposPagos =[{
      value: 'CC',
      label: 'Tarjeta de Crédito'
    }, {
      value: 'CH',
      label: 'Cuenta de Cheques'
    }];
    this.tiposPago=this.tiposPagos[0].value;
    this.months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    this.years = [];
    this.year = new Date();
    var anio = this.year.getFullYear();
    for (var i = 0; i <10; i++) {
      this.years[i] = anio+i;
    }
    this.selectedYear=anio;
  }
  cambiarTipoPago() {
    if( this.global.validateSession()===true){
      if(this.tiposPago==='CC'){
        this.screen =4;
      }
      else{
        this.screen =2;
      }
      this.updateScreen.emit(this.screen);
      this.updatetipo.emit(this.tiposPago);
    }
  }
  debitCreditCard() {
    if( this.global.validateSession()===true){
      if(this.validaciones() ===true){
        this.expDate = this.selectedYear + '-'+ this.selectedMonth;
        var startDate = '';
        var endDate = '';
        var bankAccountNo = '';
        var status = 'A';
        if(this.isValidForm()){
          var fechaVencimiento=this.expDate+'-01T01:01:01.000-04:00';
          this.loadingScreenService.startLoading();
          this.services.updateDirectDebit(this.token,this.tiposPago, this.cardNum.toString(), this.nameOnCard,this.type,fechaVencimiento, startDate, bankAccountNo, endDate, '021502095', this.selectBan,status).subscribe(data =>{
            var data2;
            if(data.HasError===undefined){
              data2=data.data;
            }
            else{
              data2=data;
            }
            if(data2.HasError==false){
              this.loadingScreenService.stopLoading();
              this.infoAfiliation.type='Tarjeta de Crédito';
              this.infoAfiliation.mCreditCardMemberName=this.nameOnCard;
              this.cardNumCut=this.convertNum(this.cardNum);
              this.infoAfiliation.mCreditCardNo=this.cardNumCut;
              this.infoAfiliation.mCreditCardMemberName=this.firstUp(this.infoAfiliation.mCreditCardMemberName);
              this.typeCard=this.typeCard;
              this.screen =5;
              this.updateScreen.emit(this.screen);
            }
            else{
              this.loadingScreenService.stopLoading();
              this.global.notif(data.ErrorDesc);
            }
          });
        }
      }
    }
  }
  convertNum(num){
    try {
      return num.substr(num.length-4);  
    } 
    catch (error) {
      return "***";
    }
  }
  firstUp(char){
    try {
      return char.charAt(0).toUpperCase() + char.toLowerCase().slice(1);
    } 
    catch (error) {
      return "***";  
    }
  }
  validaciones() {
    var sw=true;
    if(this.nameOnCard===''){
      this.global.notif("Debe colocar el nombre completo");
      sw=false;
    }
    else if(this.cardNum===''){
      this.global.notif("Debe colocar el número de la tarjeta");
    } else if(this.cvNum===''){
      this.global.notif("Debe colocar el código de seguridad");
    } else if(this.type===''){
      this.global.notif("Debe seleccionar un tipo de tarjeta.");
    }
  
    return sw;
  }
  isValidForm() {
    var isValid = false;
    
    if(this.type !== '' && this.cardNum !== '' && this.nameOnCard !== '' && this.cvNum !== ''){
      isValid = true;
    }
    return isValid;
  }
  cancel(){
    // $state.go('bills-management');
  }
}
